module.exports = __webpack_public_path__ + "static/img/cont57 (3).ee33499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (3).jpg
// module id = zlnu
// module chunks = 0